import { AfterViewInit, Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { Utils } from '../../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { BranchconfigdatesPopup } from './branchconfigdates-popup/branchconfigdates-popup.component';
import { KpiStageResultsPopup } from './kpistageresults-popup/kpistageresults-popup.component';

@Component({
    selector: 'branchconfig',
    templateUrl: './branchconfig.component.html',
    styleUrls: ['./branchconfig.component.less',
        '../branchexcellenceadmin.component.less',
        '../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class BranchConfigComponent implements AfterViewInit {
    @Output() savedEvent = new EventEmitter<any>();

    public editBranchConfigForm: FormGroup;
    subscriptionManagementId: any;
    subscriptions: any[] = [];
    AllArchetypes: any[] = [];
    mgmtId: string = '';
    data: FieldBranchDetails
    subscriptionWaveId: any;
    waveId: number = -1;
    assessmentId: number | undefined = 0;

    constructor(
        private fb: FormBuilder,
        public defaults: DefaultValuesService,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private toastrService: ToastrService,
        private matDialog: MatDialog
    ) {
        this.data = {
            MgmtId: '',
            MgmtName: '',
            Currency: '',
            CurrencyShort: '',
            CurrencySymbol: '',
            DecimalDigits: '',
            Dates: undefined
        }
        this.editBranchConfigForm = this.fb.group(
            {
                responsiblePerson: ['', Validators.required],
                archetype: ['', Validators.required],
                dates: undefined
            });
    }

    ngAfterViewInit() {
        this.subscriptionManagementId = this.defaults.managementIdMessageChanges$.subscribe(() => {
            this.getProperties();
        });
        this.subscriptionWaveId = this.defaults.wave$.subscribe(() => {
            this.getProperties();
        })
    }

    getProperties(){
        if (!this.defaults.managementid || this.defaults.managementid === '-1') return;
        const newWaveId = (this.defaults.waveId && this.defaults.waveId > 0) ? this.defaults.waveId : -1;
        if (this.mgmtId === this.defaults.managementid && this.waveId === newWaveId) return;

        this.mgmtId = this.defaults.managementid;
        this.waveId = newWaveId;
        this.getBranchDetails();
    }

    // unsubscribe to events when component is destroyed
    ngOnDestroy(): void {
        this.subscriptionManagementId.unsubscribe();
        this.subscriptionWaveId.unsubscribe();
    }

    getBranchDetails() {
        Utils.httpGetfieldBranchDetails(
            this.http,
            this.baseUrl,
            this.waveId,
            this,
            function (tthis: BranchConfigComponent, result: AssessmentBranchWaveConfig) {
                tthis.assessmentId = result.AssessmentId;
                tthis.data = {
                    MgmtId: result.MgmtId ?? '',
                    MgmtName: result.MgmtName ?? '',
                    Currency: result.Currency ?? '',
                    CurrencyShort: result.CurrencyShort ?? '',
                    CurrencySymbol: result.CurrencySymbol ?? '',
                    DecimalDigits: result.DecimalDigits ?? '',
                    Dates: {
                        ActualAssessmentDate: result?.ActualAssessmentDate,
                        ActualCheckInCall_1_Date: result?.ActualCheckInCall_1_Date,
                        ActualCheckInCall_2_Date: result?.ActualCheckInCall_2_Date,
                        ActualCheckInCall_3_Date: result?.ActualCheckInCall_3_Date,
                        ActualCheckInCall_4_Date: result?.ActualCheckInCall_4_Date,
                        ActualFinalCheckInCall_Date: result?.ActualFinalCheckInCall_Date,
                        ActualValidationCallDate: result?.ActualValidationCallDate,
                        PlannedAssessmentDate: result?.PlannedAssessmentDate,
                        PlannedValidationCallDate: result?.PlannedValidationCallDate
                    }
                };
                tthis.AllArchetypes = result.AllArchetypes;
                tthis.editBranchConfigForm.controls['responsiblePerson'].setValue(result.ResponsiblePerson);
                tthis.editBranchConfigForm.controls['archetype'].setValue(result.ArchetypeId);
                tthis.editBranchConfigForm.controls['dates'].setValue(tthis.data.Dates);
            },
            null
        )
    }

    onSave(onlyDates: boolean = false) {
        var formvalues = this.editBranchConfigForm.getRawValue();

        Utils.httpUpdateFieldBranchDetails(
            this.http
            , this.baseUrl
            , formvalues
            , this
            , this.assessmentId
            , onlyDates
            , function (tthis: BranchConfigComponent, result: boolean) {
                let objDetail = onlyDates ? 'Dates' : 'Details';
                if (result) {
                    tthis.toastrService.success(`Branch ${objDetail} were updated successfully!`);
                    tthis.savedEvent.emit(tthis.defaults.waveId);
                }
                else
                    tthis.toastrService.error(`${objDetail} could not be updated. Please, contact with administrator`);
            },
            null
        )
    }

    openSetDatesPopup() {
        const dialogRef = this.matDialog.open(BranchconfigdatesPopup, {
            panelClass: ['custom-mat-dialog_v2', 'min-width-600'],
            data: { ...this.data.Dates },
            disableClose: true,
        });

        dialogRef.componentInstance.datesChange.subscribe((configuredDates: FieldBranchDates) => {
            this.data.Dates = configuredDates;
            this.editBranchConfigForm.controls['dates'].setValue(configuredDates);
            this.onSave(true);
        });
    }

    openSetKpiStageResultsPopup() {
        const dialogRef = this.matDialog.open(KpiStageResultsPopup, {
            panelClass: ['custom-mat-dialog_v2', 'min-width-600']
        });
    }
}
